import { Flex, FormControl, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { CheckboxCmp } from '../../../../../../components/CheckboxCmp'
import { Container } from './styles'
import { v4 as uuidv4 } from 'uuid'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { FaPlus } from 'react-icons/fa'
import { InputCmp } from '../../../../../../components/InputCmp'
import { UpdateElementByPosition } from '../../../../../../Utils/Helper'
import { MdClose } from 'react-icons/md'
import { ElementoTooltipCmp } from '../../../../../../components/ElementoTooltipCmp'

interface iFormQuestaoResponse {
  id: string
  tipo: number
  enunciado: string
  alternativas?: iFormAlternativaResponse[]
  minCaixaSelecao?: number
  maxCaixaSelecao?: number
}

interface iFormAlternativaResponse {
  id: string
  texto: string
}

interface iCaixaSelecaoProps {
  questao: iFormQuestaoResponse
  Selecionar: (questaoId: string, alternativaId: string) => void
  erro: boolean
  selecionadas?: number
  pesquisaPontosPositivo?: boolean
  onAddExtras?: (questId: string, list: string[]) => void
}

export const CaixaDeSelecao: React.FC<iCaixaSelecaoProps> = ({ questao, Selecionar, erro, selecionadas, pesquisaPontosPositivo, onAddExtras }) => {
  const [Extras, setExtras] = useState<iFormAlternativaResponse[]>([])
  const [ExtrasSelecionadas, setExtrasSelecionadas] = useState<string[]>([])

  function onChangeExtras(val: boolean, id: string): void {
    if (val) {
      setExtrasSelecionadas([...ExtrasSelecionadas, id])
    } else {
      setExtrasSelecionadas(ExtrasSelecionadas.filter(e => e !== id))
    }
  }

  function ValidarErro(questoesSelecionadas: number): boolean {
    const sel = questoesSelecionadas + ExtrasSelecionadas.length
    if (sel === 0) {
      return false
    } else if (questao.minCaixaSelecao && sel < questao.minCaixaSelecao) {
      return true
    } else if (questao.maxCaixaSelecao && sel > questao.maxCaixaSelecao) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (onAddExtras) {
      onAddExtras(questao.id, Extras.filter(e => ExtrasSelecionadas.includes(e.id)).map(e => {
        return e.texto
      }))
    }
  }, [ExtrasSelecionadas, Extras])

  return (
    <Container>
      <div>
        <Text fontWeight={'600'}>{questao.enunciado}</Text>
        {(erro || ValidarErro(selecionadas ?? 0)) && ((questao.maxCaixaSelecao !== null && questao.minCaixaSelecao !== null) ? <span style={{ fontSize: '.875rem', color: 'var(--Red)' }}>* Selecione no máximo {questao.maxCaixaSelecao} e no mínimo {questao.minCaixaSelecao}</span> : <span style={{ fontSize: '.875rem', color: 'var(--Red)' }}>* Essa questão é obrigatória</span>)}
      </div>
      <Flex gap={'1rem'} mt={'.75rem'} flexDir={'column'}>
        {
          questao.alternativas?.map((e, i) => {
            return (
              <FormControl key={i} as={Flex}>
                <CheckboxCmp
                  OnChange={() => Selecionar(questao.id, e.id)}
                >
                  {e.texto}
                </CheckboxCmp>
              </FormControl>
            )
          })
        }
        {pesquisaPontosPositivo && <>
          {Extras.map((e, i2) => {
            return (<FormControl key={i2} as={'span'} d={'flex'} flexDir='row' gap={'.325rem'}>
              <CheckboxCmp
                OnChange={(check) => onChangeExtras(check, e.id)}
                isChecked={ExtrasSelecionadas.some(a => a === e.id)}
              >
              </CheckboxCmp>
              <InputCmp
                OnChange={(val) => {
                  setExtras(UpdateElementByPosition(Extras, i2, { ...e, texto: val }))
                }}
                value={e.texto}
              />
              <ElementoTooltipCmp bg={'var(--Red)'} label={'Excluir alternativa'}>
                <MdClose onClick={() => { setExtras(Extras.filter(a => a.id !== e.id)); setExtrasSelecionadas(ExtrasSelecionadas.filter(a => a !== e.id)) }} cursor={'pointer'} color={'var(--Red)'}/>
              </ElementoTooltipCmp>
            </FormControl>)
          })}
          <ButtonCmp VarColor='Green2' leftIcon={<FaPlus/>} onClick={() => { const idNovo = uuidv4(); setExtras([...Extras, { id: idNovo, texto: '' }]); setExtrasSelecionadas([...ExtrasSelecionadas, idNovo]) }}>Adicionar outra opção</ButtonCmp>
        </>}
      </Flex>
    </Container>
  )
}
